import Home from "./Home";
import OneWrapper from "./one";

export const SupervisorCollectsHome = Home;
export const SupervisorCollectsOneWrapper = OneWrapper;
